<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-766.251 -329)">
			<path d="M39.481,5.75A3.745,3.745,0,0,0,35.75,2h-30A3.761,3.761,0,0,0,2,5.75v22.5A3.761,3.761,0,0,0,5.75,32H32l7.5,7.5ZM32,24.5H9.5V20.75H32Zm0-5.625H9.5v-3.75H32Zm0-5.625H9.5V9.5H32Z" transform="translate(768.001 330.75)"/>
			<path class="a" d="M0,0H45V45H0Z" transform="translate(766.251 329)"/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-comment',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
  path.a {
    fill: none;
  }
</style>

<docs>
    IconComment

    ```js
    <b-comment />
    ```
</docs>
